/**
 * Estado visible de un préstamo.
 *
 * En la base de datos un préstamo saldado (pagado por completo) y uno
 * cancelado manualmente terminan igual: status = 'C' (el registro de pagos
 * pone 'C' automáticamente cuando la deuda llega a cero, y el escritorio
 * ares hace lo mismo). La única forma de distinguirlos es el balance
 * pendiente: se considera saldado cuando la deuda es <= 1, el mismo umbral
 * del reporte de préstamos saldados del backend.
 */

// Parsea montos que llegan como "1,234.56" o número.
export const montoANumero = (v) => parseFloat(String(v ?? "0").split(",").join("")) || 0;

/**
 * 'activo' | 'saldado' | 'cancelado' | 'incobrable' | null (status desconocido).
 * 'I' (incobrable, la deuda se castigó) no mira el balance: se castiga
 * justamente porque queda deuda.
 * balancePendiente admite número o string con comas; null/undefined
 * significa "sin dato" y nunca marca saldado.
 */
export function estadoPrestamo(status, balancePendiente) {
  const s = String(status ?? "").trim().toUpperCase();
  const saldado =
    balancePendiente != null && montoANumero(balancePendiente) <= 1;
  if (s === "C") return saldado ? "saldado" : "cancelado";
  if (s === "A") return saldado ? "saldado" : "activo";
  if (s === "I") return "incobrable";
  return null;
}
